var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject } from 'vue-property-decorator';
import { InlineCodeMirrorBase } from '../../../comps/InlineCodeMirrorBase';
import { highlightRect } from "../../../../lib/utils/browser";
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { toRect } from "../../../../lib/utils/styling";
import { compSelectorHint } from './compSelectorHint';
import './compSelectorMode';
import * as s from "./style.module.css";
let CompSelectorInput = class CompSelectorInput extends InlineCodeMirrorBase {
  render() {
    const h = arguments[0];
    const baseClass = this.getInlineCodeMirrorBaseClassName();
    return h("div", {
      "class": `${baseClass} ${s.compSelectorInput}`
    }, [this.renderInlineCodeMirrorBase(), h("button", {
      "class": s.toolBtn,
      "attrs": {
        "title": "定位组件",
        "type": "button"
      },
      "on": {
        "click": this.highlightCurrent,
        "mouseenter": this.highlightCurrent
      }
    }, [h("i", {
      "class": "fa fa-eye"
    })])]);
  }
  highlightCurrent() {
    if (!this.designer) return;
    const {
      compPath,
      renderer
    } = this.designer;
    const result = renderer === null || renderer === void 0 ? void 0 : renderer.ucQuerySelector(this.tempValue, compPath);
    const compInstance = result && result.renderer.getRefByPath(result.compPath);
    if (!compInstance) {
      var _this$uc;
      (_this$uc = this.uc) === null || _this$uc === void 0 || _this$uc.$alert('未找到对应的组件');
      return;
    }
    const rect = toRect(compInstance);
    highlightRect(rect);
  }
  get cmOptions() {
    const {
      designer
    } = this;
    return {
      mode: 'uicore-comp-selector',
      hintOptions: designer && {
        hint: compSelectorHint,
        getDesigner: () => designer,
        completeSingle: false
      },
      extraKeys: {
        'Ctrl-Space': 'autocomplete'
      }
    };
  }
  onCmReady(cm) {
    cm.on('mousedown', this.showHintDebounced);
    cm.on('keypress', this.showHintDebounced);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], CompSelectorInput.prototype, "designer", void 0);
CompSelectorInput = __decorate([Component({
  name: 'CompSelectorInput'
})], CompSelectorInput);
export default CompSelectorInput;
//# sourceMappingURL=index.js.map
